

import React, { useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CustomerProjectRequirements = () => {
  const [validated, setValidated] = useState(false);
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    company_name: "",
    contact_name: "",
    email: "",
    phone: "",
    website: "",
    project_name: "",
    project_description: "",
    project_types: [],
    main_goal: "",
    target_audience: "",
    key_features: "",
    technology_preferences: "",
    inspiration_links: "",
    start_date: "",
    end_date: "",
    budget_range: "",
    specific_requirements: "",
    additional_info: "",
  });

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const form = e.target;
  //   if (form.checkValidity() === false) {
  //     e.stopPropagation();
  //   } else {
  //     callAPI("post", "add-project-requirements", formData);
  //     alert("Thank you for submitting your project requirements!");
      
  //     navigate('/');
  //     form.reset();
  //   }
  //   setValidated(true);
  // };

  
  
  const handleSubmit = (e) => {
  e.preventDefault();
  const form = e.target;

  if (form.checkValidity() === false) {
    e.stopPropagation();
  } else {
    callAPI("post", "add-project-requirements", formData);

    toast.success("✅ Thank you! Project requirements submitted.", {
      autoClose: 2000,
    });

    setTimeout(() => {
      navigate('/');
    }, 2000); // matches toast duration

    form.reset();
  }

  setValidated(true);
};
  const handleCheckboxChange = (value) => {
    const updated = formData.project_types.includes(value)
      ? formData.project_types.filter((v) => v !== value)
      : [...formData.project_types, value];
    setFormData({ ...formData, project_types: updated });
  };

  return (
    <UIBody
    loading={loading}

      content={
        <div className="container my-5">
          <h2 className="mb-4">📄 Project Requirements Collection</h2>
          <form
            noValidate
            onSubmit={handleSubmit}
            className={validated ? "was-validated" : ""}
          >
            <div className="accordion" id="projectFormAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                  >
                    👤 Client Information
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <input type="text" className="form-control mb-2" placeholder="Company Name" required value={formData.company_name} onChange={(e) => setFormData({ ...formData, company_name: e.target.value })} />
                    <input type="text" className="form-control mb-2" placeholder="Contact Name" required value={formData.contact_name} onChange={(e) => setFormData({ ...formData, contact_name: e.target.value })} />
                    <input type="email" className="form-control mb-2" placeholder="Email" required value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                    <input type="text" className="form-control mb-2" placeholder="Phone" required value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                    <input type="url" className="form-control" placeholder="Website" value={formData.website} onChange={(e) => setFormData({ ...formData, website: e.target.value })} />
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                  >
                    🛠️ Project Overview
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    <input type="text" className="form-control mb-2" placeholder="Project Name" required value={formData.project_name} onChange={(e) => setFormData({ ...formData, project_name: e.target.value })} />
                    <textarea className="form-control mb-2" placeholder="Project Description" rows="3" required value={formData.project_description} onChange={(e) => setFormData({ ...formData, project_description: e.target.value })} />

                    {[
                      "Website Development",
                      "Mobile App Development",
                      "Branding",
                      "Marketing",
                      "E-commerce",
                    ].map((type) => (
                      <div className="form-check mb-2" key={type}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={type}
                          checked={formData.project_types.includes(type)}
                          onChange={() => handleCheckboxChange(type)}
                        />
                        <label className="form-check-label">{type}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                    🎯 Project Goals
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    <textarea className="form-control mb-2" placeholder="Main Goal" required value={formData.main_goal} onChange={(e) => setFormData({ ...formData, main_goal: e.target.value })} />
                    <textarea className="form-control" placeholder="Target Audience" required value={formData.target_audience} onChange={(e) => setFormData({ ...formData, target_audience: e.target.value })} />
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                    🔍 Features & Requirements
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    <textarea className="form-control mb-2" placeholder="Key Features" required value={formData.key_features} onChange={(e) => setFormData({ ...formData, key_features: e.target.value })} />
                    <input type="text" className="form-control mb-2" placeholder="Technology Preferences" value={formData.technology_preferences} onChange={(e) => setFormData({ ...formData, technology_preferences: e.target.value })} />
                    <input type="url" className="form-control" placeholder="Inspiration Links" value={formData.inspiration_links} onChange={(e) => setFormData({ ...formData, inspiration_links: e.target.value })} />
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                    📅 Timeline & Budget
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    <input type="date" className="form-control mb-2" value={formData.start_date} onChange={(e) => setFormData({ ...formData, start_date: e.target.value })} />
                    <input type="date" className="form-control mb-2" value={formData.end_date} onChange={(e) => setFormData({ ...formData, end_date: e.target.value })} />
                    <input type="text" className="form-control" placeholder="Budget" value={formData.budget_range} onChange={(e) => setFormData({ ...formData, budget_range: e.target.value })} />
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                    🗒️ Additional Information
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    <textarea className="form-control mb-2" placeholder="Specific Requirements" value={formData.specific_requirements} onChange={(e) => setFormData({ ...formData, specific_requirements: e.target.value })} />
                    <textarea className="form-control" placeholder="Anything Else?" value={formData.additional_info} onChange={(e) => setFormData({ ...formData, additional_info: e.target.value })} />
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-4">
              <button type="submit" className="btn btn-primary px-4">
                Submit Project Details
              </button>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default CustomerProjectRequirements;

